import script from "./AccessibilitySection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessibilitySection.vue?vue&type=script&lang=ts&setup=true"

import "./AccessibilitySection.vue?vue&type=style&index=0&id=3af7c9d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af7c9d7"]])

export default __exports__